/* eslint-disable @typescript-eslint/no-misused-promises */
import React from "react";

import { Form, Input, Select } from "antd";
import { omit } from "lodash-es";

import { IFormsProps } from "../../../types";
import FormFooter from "../FormFooter";

interface IFormInputs {
    title: string;
}

// TODO: ability to specify what status it changed to
export default function ContactStatusChangedTriggerForm({
    initialData,
    canDelete = true,
    onCancel,
    onSubmit,
    onDelete,
}: IFormsProps) {
    const [form] = Form.useForm();
    const initialValues = {
        title: initialData?.label ?? "",
    };

    const sumbit = (data: IFormInputs) => {
        onSubmit({
            ...omit(data, ["title"]),
            label: data.title,
        });
    };

    return (
        <div className="form-layout">
            <Form layout="vertical" form={form} initialValues={initialValues} onFinish={sumbit}>
                <Form.Item
                    label="Trigger Name"
                    name="title"
                    rules={[{ required: true, message: "Trigger Name is required field" }]}
                >
                    <Input placeholder="Trigger Name" />
                </Form.Item>
                <Form.Item
                    label="Status Changed To"
                    name="status"
                    rules={[{ required: true, message: "Status Changed To is required field" }]}
                >
                    <Select
                        className="field"
                        options={[
                            { value: "status1", label: "Status1" },
                            { value: "status2", label: "Status2" },
                        ]}
                        placeholder="Select"
                    />
                </Form.Item>
                <FormFooter onCancel={onCancel} canDelete={canDelete} onDelete={onDelete} />
            </Form>
        </div>
    );
}
